import { camelize, processKeys } from 'helpers/syntaxHelper';
import { Response } from 'routes/HumanResourcesModule/business/types';

// camelize only the prefix for pivoted keys (with '..')
const camelizePivotedKeyPrefix = (
    key: PivotedField<string, string>,
): PivotedField<string, string> => {
    if (!key.includes('..')) {
        return camelize(key);
    }
    const prefix = key.split('..')[0];
    const camelizedPrefix = camelize(prefix);
    return key.replace(prefix, camelizedPrefix) as PivotedField<string, string>;
};

export function pivotedKeysPostProcessingMiddleware<T extends object[]>(data: {
    data: Response<T>;
}): { data: Response<T> } {
    const processedResponseData = {
        data: processKeys(camelizePivotedKeyPrefix, data.data.data),
        columns: processKeys(camelizePivotedKeyPrefix, data.data.columns),
    };
    return { data: processedResponseData };
}
